import { svg } from "lit";
/** Other/generic event icon — calendar with star (24x24, fill=currentColor) */
export const otherIcon = svg `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Zm0 16H5V8h14v11Z"/>
    <path d="m12 10-1.12 2.27L8.5 12.64l1.75 1.71-.41 2.41L12 15.67l2.16 1.09-.41-2.41 1.75-1.71-2.38-.37L12 10Z"/>
  </svg>`;
//# sourceMappingURL=other.js.map